import { StyleWrapper } from "./style";

export const PickerStyleWrapper: React.FC<{ id?: string }> = ({
  id,
  children,
}) => {
  return <StyleWrapper id={id}>{children}</StyleWrapper>;
};
